import { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import Logo from "@/components/Logo";
import SEO from "@/components/SEO";

export default function AdminLogin() {
  const { login, user } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user) nav("/admin/dashboard", { replace: true });
  }, [user, nav]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email.trim(), password);
      toast.success("Welcome back.");
      nav("/admin/dashboard", { replace: true });
    } catch (err) {
      const detail = err?.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="grid min-h-screen bg-[#f9f8f5] text-[#202124] lg:grid-cols-2" data-testid="admin-login-page">
      <SEO title="Admin Login — Saans Wellness" description="Saans Wellness admin console." path="/admin" noindex />
      <div className="hidden bg-[#1f5d3a] p-12 lg:flex lg:flex-col lg:justify-between">
        <Logo variant="horizontal" wordColor="#ffffff" subColor="#f2c39a" arcColor="#ffffff" sproutColor="#ffffff" />
        <div>
          <h1 className="font-serif text-5xl leading-tight text-white">The Saans<br /> operations console</h1>
          <p className="mt-4 max-w-sm text-[#d6e6dc]">Manage franchise enquiries, your customer database and homepage offers — all in one place.</p>
        </div>
        <div className="text-sm text-[#a9c6b6]">© {new Date().getFullYear()} Saans Wellness Pvt Ltd</div>
      </div>

      <div className="flex items-center justify-center p-6">
        <form onSubmit={submit} className="w-full max-w-md rounded-2xl border border-[#e7e0d6] bg-white p-8 card-shadow md:p-10" data-testid="admin-login-form">
          <div className="eyebrow text-[#d46a1d]">Admin</div>
          <h2 className="mt-2 font-serif text-3xl text-[#202124]">Sign in to console</h2>

          <div className="mt-8 space-y-5">
            <div>
              <label className="mb-1.5 block text-sm font-medium text-[#4a4a48]">Email</label>
              <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                className="form-field" placeholder="admin@saanswellness.com" data-testid="admin-email-input" />
            </div>
            <div>
              <label className="mb-1.5 block text-sm font-medium text-[#4a4a48]">Password</label>
              <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
                className="form-field" placeholder="••••••••" data-testid="admin-password-input" />
            </div>
            <button type="submit" disabled={loading}
              className="w-full rounded-full bg-[#d46a1d] px-6 py-3.5 text-sm font-semibold text-white transition-transform hover:scale-[1.02] hover:bg-[#c05f16] disabled:opacity-60"
              data-testid="admin-login-submit">
              {loading ? "Signing in…" : "Enter Console"}
            </button>
            <Link to="/" className="block text-center text-sm font-medium text-[#6b6a65] hover:text-[#d46a1d]" data-testid="admin-back-home">
              ← Back to website
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
}
